// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","header":"header-239EC","route":"route-3fhWp","disclaimer__wrapper":"disclaimer__wrapper-rlFZJ"};